import Immutable from 'seamless-immutable'
import * as types from './types'

export const INITIAL_STATE = Immutable({
  filters: {
    categoryId: null,
    title: null
  },
  categories: {
    fetching: false,
    list: []
  },
  highlights: {
    fetching: false,
    fetchingMore: false,
    list: [],
    pagination: {
      total: 0,
      lastPage: 0,
      currentPage: 0
    }
  },
  recents: {
    fetching: false,
    fetchingMore: false,
    list: [],
    pagination: {
      total: 0,
      lastPage: 0,
      currentPage: 0
    }
  },
  selectedItem: {
    fetching: false,
    data: null
  }
})

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.FETCH_KNOWLEDGE_BASES_CATEGORY_LIST: {
      return state.setIn(['categories', 'fetching'], true)
    }

    case types.RECEIVE_KNOWLEDGE_BASES_CATEGORY_LIST: {
      return state
        .setIn(['categories', 'fetching'], false)
        .setIn(['categories', 'list'], [...action.payload.res.data])
    }

    case types.FETCH_KNOWLEDGE_BASES_HIGHLIGHTS_LIST: {
      return state
        .setIn(['highlights', 'fetching'], !action.payload.fetchMore)
        .setIn(['highlights', 'fetchingMore'], !!action.payload.fetchMore)
    }

    case types.RECEIVE_KNOWLEDGE_BASES_HIGHLIGHTS_LIST: {
      return state
        .setIn(['highlights', 'fetching'], false)
        .setIn(['highlights', 'fetchingMore'], false)
        .setIn(
          ['highlights', 'list'],
          [
            ...(action.payload.fetchMore ? state.highlights.list : []),
            ...action.payload.res.data
          ]
        )
        .setIn(['highlights', 'pagination'], {
          ...state.highlights.pagination,
          ...action.payload.res.pagination
        })
    }

    case types.FETCH_KNOWLEDGE_BASES_RECENTS_LIST: {
      return state
        .setIn(['recents', 'fetching'], !action.payload.fetchMore)
        .setIn(['recents', 'fetchingMore'], !!action.payload.fetchMore)
    }

    case types.RECEIVE_KNOWLEDGE_BASES_RECENTS_LIST: {
      return state
        .setIn(['recents', 'fetching'], false)
        .setIn(['recents', 'fetchingMore'], false)
        .setIn(
          ['recents', 'list'],
          [
            ...(action.payload.fetchMore ? state.recents.list : []),
            ...action.payload.res.data
          ]
        )
        .setIn(['recents', 'pagination'], {
          ...state.recents.pagination,
          ...action.payload.res.pagination
        })
    }

    case types.FETCH_SELECTED_ITEM_KNOWLEDGE_BASES: {
      return state
        .setIn(['selectedItem', 'fetching'], true)
        .setIn(['selectedItem', 'data'], null)
    }

    case types.RECEIVE_SELECTED_ITEM_KNOWLEDGE_BASES: {
      return state
        .setIn(['selectedItem', 'fetching'], false)
        .setIn(['selectedItem', 'data'], action.payload.data)
    }

    case types.SET_FILTERS_KNOWLEDGE_BASES: {
      return state.setIn(['filters'], {
        ...state.filters,
        ...action.payload.filters
      })
    }

    case types.SET_ITEM_KNOWLEDGE_BASES: {
      return state.setIn(
        [action.payload.key, 'list'],
        state[action.payload.key].list.map((listItem) =>
          listItem.id === action.payload.item.id
            ? action.payload.item
            : listItem
        )
      )
    }

    default: {
      return state
    }
  }
}

export default reducer
